import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellOff } from 'lucide-react';
import { fetchAccountSettings } from '../../utils/accountSettingsApi';

const font = "'Inria Serif', serif";

// Owner-only passive reminder pill. Renders ONLY when the venue owner has turned
// OFF "Receive messages from guests" (privacy.receive_venue_messages === false).
// Tapping opens the venue privacy page to turn guest messages back on. It
// self-fetches account settings so it can be dropped onto any /venue/* owner
// surface, and refreshes when the privacy toggle dispatches a change event.
// Only the venue OWNER ever lands on /venue/* routes (staff use /staff-* routes
// with their own header), so this is inherently owner-scoped.
export function VenueGuestMessagesOffPill({ dataTestId = 'venue-guest-messages-off-pill', style }) {
  const navigate = useNavigate();
  const [messagesOff, setMessagesOff] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      fetchAccountSettings()
        .then((settings) => {
          if (!cancelled) setMessagesOff(settings.privacy?.receive_venue_messages === false);
        })
        .catch(() => {});
    };
    load();
    window.addEventListener('allure:venue-messages-pref-changed', load);
    return () => {
      cancelled = true;
      window.removeEventListener('allure:venue-messages-pref-changed', load);
    };
  }, []);

  if (!messagesOff) return null;

  return (
    <button
      type="button"
      data-testid={dataTestId}
      onClick={() => navigate('/venue/account-settings/privacy')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: '6px 13px',
        borderRadius: 999,
        border: '1px solid rgba(214, 158, 46, 0.40)',
        background: 'var(--status-warning-surface)',
        color: 'var(--status-warning-text)',
        fontFamily: font,
        fontSize: 12.5,
        fontWeight: 700,
        letterSpacing: 0.1,
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(214, 158, 46, 0.20)',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <BellOff size={13} strokeWidth={2.4} />
      Guest messages off
    </button>
  );
}

export default VenueGuestMessagesOffPill;
